export default {
	'common':{
		'select':'sélectionner',
		'graph_loading': "Chargement des données...",
		'month_Names': ['Janv', 'Févr', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
		'graph_shortMonths': ['Janv', 'Févr', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
		'graph_day_name': ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		'graph_export': "Export",
		'graph_printButt': "Imprimer le graphique",
		'graph_down_PNG': "Télécharger l'image PNG",
		'graph_down_JPG': "Télécharger l'image JPEG",
		'graph_down_PDF': "Télécharger le document PDF",
		'graph_down_SVG': "Télécharger le vecteur SVG",
		'graph_zoom_reset': "Réinitialiser le zoom",
		'Valid request.': 'Valid request.',
		'Warning': 'Warning',
	},
	'main':{
		'titleStatistics':'statistique',
		'titleManual':'manuel',
		'titleDownload':'téléchargement',
		'titleArchives':'archives',
		'titleStream':'stream',
		'titleRealtime':'temps réel',
		'titlePlay':'jouer',
		'titleDanger': 'erreur/Ne pas courrir',
		'titleWarning': 'en cours',
		'titleSettings':'ajustage',
		'titleSD':'disponible sur SD:',
		'titleHDD':'disponible sur SSD:',
		'titleCamera': 'CAMERA:',
		'titleLogout': 'Connectez - Out',
		'status':'l’état',
		'error':'erreur',
		'running':'en cours',
		'notRunning': 'Ne pas courrir',
		'downloadingFile':'Téléchargement du fichier',
		'preparingFile':'Préparation du fichier'
	},
	'login':{
		'Username':'utilisateur',
		'Password':'mot de passe',
		'Login':'Login',
	},
	'dashboard':{
		'measuringTgl':'mesurage',
		'noiseTgl':'bruit',
		'weatherTgl':'météo',
		'adioTgl':'ADIO'
	},
	'graphs':{
		'export':{
			'Print chart':'imprimer graphique',
			'Download':'téléchargement',
			'image':'image',
		},
		'nodata': "NO DATA",
		'errNoise': "Problem with noise device",
		'errWeath': "Problem with weather device",
		'errAdio': "Problem with ADIO device",
		'NOISE':'bruit',
		'SPECTRUM':'spectre',
		'WEATHER':'météo',
		'ADIO': 'ADIO',
		'STATISTICS':'statistique',
		'statTitle':'Titre',
		'statFrom':'de',
		'statTo':'à',
		'load':'charge',
		'markers':'Markers',
	    'dailyNotes': 'Daily notes',
	    'preload': 'Manual graph loading',
	    'sync': 'Sync graphs',
	    'reset': 'Reset zoom',
	    'exportGraph': 'Export graph',
	    'hideShow': 'Hide / Show',
		'markersCat':{
			'type':'Type',
			'color':'Color',
			'single': 'single',
			'toggle': 'toggle',
			'keybind': 'Keybind',
			'learn':'Learn',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete':'Delete',
			'save': 'Save',
			'note':'Notes',
		},
		'markersTable':{
			'name':'Name',
			'startTime': 'Start time',
			'endTime': 'End time',
			'type': 'Type'
		}
	},
	'calendar':{
		'title': 'calendrier',
		'noise':'bruit',
		'audio':'audio',
		'weather':'météo',
		'video':'video',
		'adio':'ADIO',
	},
	'streamPopover':{
		'title':'stream',
		'Audio':'audio',
		'Video':'video',
		'StartManRec': 'Manual Recording',
		'StopManRec': 'Stop recording',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop stream',
	},
	'download':{
		'title':'téléchargement',
		'popOver':{
			'XML':'donnée XML',
			'XMLWeekly':'donnée XML par semaine',
			'Raw':'donnée RAW',
			'Global':'donnée global',
			'weather':'TXT météo',
		}
	},
	'archives':{
		'popOver':{
			'Global':'donnée global',
			'Noise':'bruit',
			'Audio':'audio',
			'Video':'video',
			'Weather':'météo',
			'Adio': 'ADIO',
			'Compressed': 'comprimé',
		},
		'audioPopOver':{
			'downlRec': 'Télécharger l\'enregistrement',
			'range': 'gamme',
		},
		'video':'video',
		'global':'donnée global',
		'weather':'météo',
		'noise':'bruit',
		'audio':'audio',
		'name':'archive',
		'Delete':'effacer',
		'Download':'téléchargement',
		'NorReview':'NorReview',
		'Thumbnail':'miniature',
		'Filename':'fichier',
		'Duration':'durée',
		'Size':'dimension',
		'Close':'fermer',
		'adio': 'ADIO',	
		'compressed': 'FICHIERS COMPRESSÉS',
	}, 
	'settings':{
		'name':'Ajustage',
		'save':'enregistrer',
		'addButt':'ajouter',
		'preTrigg': 'pré-déclenchement',
		'Trigg': 'déclencher',
		'postTrigg':'post-déclenchement',
		'warning': 'Attention',
		'continue': 'continuer',
		'cancel': 'Annuler',

		'interface':{
			'settingsName':'VUE',
			'Realtime display':'indication en temp réel [s]',
			'Language':'langue',
			'Lt':'selection zone L/t',
			'Spectrum':'selection zone spectrale',
			'Weather':'selection zone météo',
			'Adio': 'selection zone ADIO',
			'Manual':'definition zone manuel',
			'Dynamic':'definition zone dynamique',
			'noiseTriggerLevel':'barrière sonore de déclenchement',
			'spectrumTriggerLevel':'barrière spectrale de déclenchement',
			//Options
			'english':'Anglais (EN)',
			'austria':'Allemand (AT)',
			'german':'Allemand (DE)',
			'french':'français (FR)',
			'slovensko':'Slovensko (SI)',
		},
		'download':{
			'settingsName':'Téléchargement',
			'Compression':'compression',
			'No compression':'sans compression',
			'Zip compression':'compression ZIP ( économise largeur de bande)',
			'Noise':'bruit',
			'Weather':'météo',
			'Global Values':'donnée global',
			'Special values':'donnée special',
			'Audio':'audio',
			'Video':'video',
			'Markers':'Marqueurs',
			'Statistics':'statistique',
			'statisticsTemplate':'modèle',
			'statisticsRename':"renommer le modèle"
		},
		'audioRecording':{
			'settingsName':'Phonogramme',
			'Format':'format',
			'Audio Offset':'près-déclanhement pour phonogramme [s]',
			'Day':'jour',
			'Night':'nuit',
			'Optional 1':'option 1',
			'Optional 2':'option 2',
			'RecDur':'durée du phonogramme [s]',
			'Threshold':'valeur de seuil (dBA)',
			'Start':'temps de déclanchement (HH)',
			'Stop':'temps de l\'arrêt (HH)',
			'Weather':'barrière de déclanchement météo',
			'Windspeed':'vitesse du vent',
			'Temperature':'température',
			'Air':'pression d\'air',
			'Precipitation':'précipitation',
			'Humidity':'humidité',
			//Options
			'Disable':'désactiver',
			'Lower':'au-dessous',
			'Greater':'au-dessus',
			'Both':'les deux',
			'lowerThan':'au-dessous',
			'greaterThan':'au-dessus',
		},
		'dynamicDns':{
			'settingsName':'DNS dynamique',
			'Address':'adresse',
			'Provider':'fournisseur de services',
			'Username':'utilisateur',
			'Password':'mot de passe',
			'IP':'IP',
		},
		'alertMessaging':{
			'settingsName':'Avertissement',
			'createGroupButton':'creation d\'une nouvelle groupe',
			'createGroupDialog':'Êtes-vous sûr de créer une nouvelle groupe?',
			'deleteGroupDialog':'Êtes-vous sûr de supprimer une groupe?',
			'deleteEmailDialog':'Êtes-vous sûr de supprimer cet e-mail/MISISDN?',
			'dialogConfirm':'valider',
			'dialogContinue':'continuer',
			'dialogCancel':'annuler',
			'MSISDN-E-Mail':'À quel (s) groupe (s) souhaitez-vous ajouter le destinataire?',
			'Add MSISDN':'ajouter MSISDN',
			'Add E-mail':'ajouter E-mail',
			'DeleteButton': 'effacer',
			'DeleteGroup':'supprimer groupe',
			'DeleteRecip': 'supprimer le destinataire',
			'DeleteEmail':'supprimer E-mail / MSISDN',
			'TestEmail':'Envoyer un e-mail / SMS de test',
			'Resend after':'renvoyer après',
			'Threshold day':'valeur de seuil pour jour',
			'Threshold Night':'valeur de seuil pour nuit',
			'Threshold Opt 1':'valeur de seuil pour Opt. 1',
			'Threshold Opt 2':'valeur de seuil pour Opt. 2',
			'Running Average Level':'niveau moyen courant',
			'Weather trigger': 'valeur de seuil pour météo',
			'System reboot':'redémarrage du système',
			'Connection with meter lost':'Connexion avec sonomètre perdu',
			'FTP server error':'Erreur de server FTP',
			'Critical memory on meter':'mémoire critique au sonomètre Nor140',
			'Critical disk space':'mémoire critique sur l\'ordinateure',
			'Microphone check error':'Erreur de Microphon-Check',
			'Battery mode':'mode batterie',
			'Connection with Weather station lost':'connection avec station météo perdu',
			'LEQ':'LEQ jour',
			'Inbound (MSISDN)':'entrée (SMS):',
			'Status':'etat:',
			'GPS':'GPS:',
			'Threshold change':'changement du valeur de seuil:',
			'Email settings':'ajustage e-mail',
			'Sender Email':'e-mail de l\'expéditeur',
			'Password':'mot de passe',
			'SMTP server':'server SMTP',
			'SMTP port':'port pour SMTP',
			'noRepeat':'pas de répétition',
			'resendAft':'Renvoyer après',
			//Options
			'min':'minimum',
			'disabled':'désactiver',
			'groupsError':'Veuillez sélectionner des groupes!',
			'emailSent':'Message envoyé avec succès'
		},
		'FTPSending':{
			'settingsName':'Envoyer FTP',
			'FTP Address':'adress FTP',
			'Refresh Rate':'fréquence de rafraîchissement',
			'Username':'utilisateur',
			'Password':'mot de passe',
			'Port':'porte',
			'Values':'valeurs à envoyer',
			//Options
			'Disable':'désactiver',
			'sec':'seconde',
			'min':'minute',
			'hour':'heure',
			'measur':'bruit',
			'weath':'météo',
			'audio':'audio',
			'global':'global',
			'video':'video',
		},
		'geographicPosition':{
			'settingsName':'Position géographique',
			'Latitude':'latitude[°]',
			'Longitude':'longitude[°]',
			'Height':'altitude[m]',
		},
		'weather':{
			'settingsName':'Météo',
			'Weather':'station de météo',
			'values':'valeur',
			'SetDevice':'définir le périphérique',
			//Options
			'NoWeather':'pas de station météo',
			'reinhardt':'Reinhardt MWS 5MV',
			'reinhardtRain':'Reinhardt MWS 5MV avec de la pluie',
			'thiesClima':'Thies Clima sensor US',
			'vaisala':'Vaisala WXT520',
			'kw360': 'ONWA KW-360',
		},
		'delete':{
			'settingsName':'Supprimer/Compresse',
			'autoDelete':'supprimer automatiquemen les donnée plus vieilles que',
			'autoCompress':'Compression automatique les donnée plus vieilles que',
			'Disable':'désactiver',
			'Manual delete':'supprimer manualement',
			'Values':'valeur',
			'Delete':'supprimer',
			//Options
			'day':'jour',
			'week':'semaine',
			'month':'mois',
			'measur':'bruit',
			'weath':'météo',
			'audio':'audio',
			'global':'global',
			'logs':'enregistrements',
			'statistics':'statistique',
			'video':'video',
			'adio': 'ADIO'
		},
		'device':{
			'settingsName':'Nor 140',
			'Selection':'selection du microphone',
			'Polarisation':'polarisation du microphone',
			'Frequency':'mode fréquence',
			'Resolution':'résolution',
			'Duration':'durée',
			'Meter':'Meter scale',
			'Values':'valeur',
			'Special':'paramètres speciaux',
			'Advance':'avance',
			'Mic check':'valeur du Mic-Check [dB]:',
			'Mic check time':'Mic-Check à [HH]:',
			'SDFreeSpace':'alarme  pour capacitée libre sur la carte SD [%]',
			'Restart':'redémarrer bruit',
			'Set instrument':'installer sonomètre',
			'Format':'format de la carte SD',
			'CheckSD':'vérifier capacitée libre de la carte SD',
			'formatSDdialog':'cette action utilise jusque à 5 minutes! Souhaitez-vous toujours continuer?',
			'decrease':'diminution',
			'increase':'augmentation',
			'value':'valeur',
			'threshold':'valeur de seuil (dBA)',
			'timeControlled':'contrôlé par temps',
			'measurementControlled':'contrôlé par mesure',
			'start_stop':'temps de démarration / temps d\'arrêt',
			'startTime':'temps de démarration',
			'endTime':'temps d\'arrêt',
			'trigger':'déclencheur',
			'duration':'durée',
			'test':'teste',
			'testOpt': 'Test for installed options',
			'restartNoise':'redémarrer bruit',
			'increasedVol': 'volume accru',
			'decreasedVol': 'diminution du volume',
			'autostart': 'Auto Start-Stop',
			//Options
			'On':'allumé',
			'Off':'éteint',
			'Standard':'standard',
			'Disable':'désactiver',
			'iepe':'IEPE',
			'line':'Line',
			'horizontal':'1214/16/17 horizontal',
			'vertical':'1214/16/17 vertical',
			'11octave':'1/1 octave',
			'13octave':'1/3 octave',
			'11wOctave':'1/1w octave',
			'13wOctave':'1/3w octave',
			'movingAverage':'moyenne mobile',
			'movingValue': 'valeur mobile',
			'midnight': "minuit - 00h",
			'noon': "midi - 12h",
			'freeSpace': 'Espace libre: ',
			'instrumentSent': 'Jeu d\'instrumentst',
			'start':'Start',
			'stop':'Stop',
			'days':'Days',
			'types':'Types',
			'startstopActive':'Active',
			'warningMeasRunning':'Les valeurs ne seront pas envoyées à l\'instrument si la mesure est en cours!'
		},
		'video':{
			'settingsName':'Video',
			'Present':'presenter',
			'Manual':'enregistrement manuel',
			'Triggering':'Seuil de déclenchement vidéo',
			'Moving detection':'détection en mouvement',
			'Settings':'ajustage',
			'Pre':'pre-enregistrement',
			'Post':'post-enregistrement',
			'No device':'pas d\'appareil',
			'Video camera':'camera de video',
			'SetDevice': 'définir le périphérique',
			'formatSDWarning': 'Please wait until SD card free space indicatior is on 100%',
		},
		'adio':{
			'settingsName':'ADIO',
			'Present':'présent',
			'ADIO':'ADIO boîte',
			'NoDevice':'pas d\'appareil',
			'DigitalOut':'entrée digital',
			'DigitalIn':'sortie digital',
			'AnalogIn':'entrée analogue',
			'AnalogOut':'sortie analogue',
			'AnalogLowerLimit':'limite inférieure analogue 0V / 4mA',
			'AnalogUpperLimit':'limite supérieure analogue 10V / 20mA',
			'Pleaseinput':'"demande d\'entrer"',
			//Options
			'On':'allumé',
			'Off':'éteint',
		},
		'norcloud':{
			'settingsName':'NorCloud',
			'IdNor':'Nor140 ID',
			'syncTime':'Synchronization Time',
			'syncData': 'Send Noise Data',
			'syncRec': 'Send Audio Recordings',
			'sendAlerts': 'Send Alerts',
			'recSett': 'Receive Settings',
			'applySett': 'Apply Received Settings',
			//Options
			'On':'On',
			'Off':'Off',
			'disable':'Disable',
			'min':'min',
			'hour':'hour',
			'now': 'When settings are recevied',
			'fhour': 'At full hour',
			'break': 'When Automic check is performed',
		},
		'statistics':{
			'settingsName':'Statistiques',
			'reportSending':{
				'settingsName': 'Automatic Report Sending',
				'Name': 'Name',
				'Title': 'Title',
				'Duration': 'Report type',
				'Days': 'Days to send',
				'Hours': 'Send at',
				'Range': 'Past days',
				'Email': 'E-mail', 
				'Language':'langue'
			},
			'options': {
				'Range': 'Range',
				'Daily': 'Daily',
				'On Event': 'On Event',
			}
		},
		'status':{
			'settingsName':'Systeme',
			'Reboot':'redemarrer le systeme',
			'Reboot confirm': 'Êtes-vous sûr de vouloir redémarrer le système?',
			'Reboot success': 'Moins de 1 minute pour redémarrer!',
			'Reboot cancel': 'Redémarrage annulé',
			'Restart confirm':'Êtes-vous sûr de vouloir redémarrer N140?',
			'Restart Warning': 'N140 sera de retour en ligne dans 1min!',
			'Restart success': 'N140 is back online!',
			'Restart cancel': 'Annulé',
			'Version':'version',
			'Release':'date de sortie',
			'PCFree':'alarme  pour capacitée libre sur le PC [%]',
			'SDD':'SSD',
			'memory':'mémoire',
			'camera':'camera SD',
			'n140':'Nor140 SD',
			'cpu':'CPU pourcentage',
			'firmware':'logiciel interne',
			'logs':'enregistrement historique',
			'download':'téléchargement',
			'total':'totale',
			'free':'libre',
			'used':'utilisé',
			'gbOrMore':'2GB ou plus',
			'of':'de',
			'users': 'utilisateurs',
			'username':'Nom d\'utilisateur',
			'password':'mot de passe',
			'adminUsr': 'Administrator',	
			'noiseUsr': 'Ordinaire',
			'guestUsr': 'Client'
        	}
	},
	'errors':{
		'n140':'Nor140',
		'weather': 'météo',
		'adio': 'ADIO',
		'cameraSD':'CAMERA SD Card over 80% full!'
	},
	'codes':{
		"13":"pas de connection au port serielle",
		"16":"une ou plusieures options ne sont pas retrouvé",
		"64":"OK - pas d'erreurs",
		"89":"temps de mesure trop long  pour Synchro",
		"90":"entrée inconnu",
		"91":"option pas installée",
		"92":"I/O bloqué",
		"93":"aucune table de marqueur pour le fichier sélectionné",
		"94":"expression trop long sans leimiteurs",
		"97":"erreur dans l'appareil",
		"99":"pas de module DECT trouvé",
		"100":"pas de character lu",
		"101":"nombre pas accepté",
		"102":"expression trop long",
		"104":"données pas valide",
		"105":"numéro hors de portée",
		"106":"pas de mesur démarré",
		"108":"délai sur le paramètre de chaîne à une commande",
		"109":"software v2.x pas installé (Nor118)",
		"110":"erreur au format du texte",
		"111":"software v3.x pas installé (Nor118)",
		"112":"mémoire pleine",
		"116":"tous les operation memoire bloqué pour raison d'erreur au memoir",
		"117":"erreur de paramètre pendant calibration du sonomètre",
		"118":"erreur inconnu",
		"119":"erreur inconnu",
		"121":"dossier pas défini",
		"122":"dossier pas trouvé",
		"123":"operation du memoir OK",
		"124":"carte SD pas présent",
		"125":"carte SD non alimentée",
		"126":"carte SD protégée en écriture",
	}
}


// WEBPACK FOOTER //
// ./src/localization/translations/local-FR.js